import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import ControlPannelCommandButton from "./ControlPannelCommandButton";
// INTERFACES
import { RootState } from "../../../app/store";
import { ControlPanelCommandsInterface } from "../../../interfaces/EdgeManagement.interface";

function ControlPanelCommands({ carService }: ControlPanelCommandsInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className={`drawer__box__${theme} mt-3`}>
			<div>
				<div
					style={{
						flexWrap: "wrap",
						alignItems: "center",
						display: "flex",
						justifyContent: "center",
					}}
				>
					{/** ******************************************************** */}
					{/** CAR TO LOBBY  */}
					<ControlPannelCommandButton
						name='Car To Lobby'
						carService={carService}
						defaultState='CTL'
						validStates={["CTL", "RTL"]}
					/>
					{/** ******************************************************** */}
					{/** INDEPENDENT SERVICE  */}
					<ControlPannelCommandButton
						name='Independent Service'
						carService={carService}
						defaultState='INS'
						validStates={["INS", "IND"]}
					/>
					{/** ******************************************************** */}
					{/** MAINTENANCE SUTDOWN  */}
					<ControlPannelCommandButton
						name='Maintenance Shutdown'
						carService={carService}
						defaultState='MSD'
						validStates={["MSD", "OTS", "HEO", "EOF"]}
					/>
				</div>
			</div>
		</div>
	);
}

export default ControlPanelCommands;
